import { routes } from "@/pages/taskpane/shared/constants/routes";
import { useNavigate } from "react-router-dom";
import { useSettingStore } from "@/pages/taskpane/shared/stores";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

type Props = {
  resourceType?: string;
};

const NoResultFound = ({ resourceType }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { defaultResourceType } = useSettingStore();

  const handleToChangeLocation = () => {
    navigate(routes.setting + "?targetResourceType=" + resourceType);
  };

  return (
    <div className="w-full flex flex-1 flex-col gap-3 text-base pt-4 px-2">
      {resourceType === defaultResourceType ? (
        <>
          <p>{t("There are no available resources at the chosen time at your location or in your favorites.")}</p>
          <p>{t("You have these options:")}</p>
          <p>{t("Change the meeting time.")}</p>
          <p>
            <Trans
              i18nKey="Use the <1>Find Available Time</1> button to choose a new time."
              components={{ 1: <strong /> }}
            />
          </p>
        </>
      ) : (
        <>
          <p>
            <Trans
              i18nKey="The resource type <1>'{{resourceType}}'</1> does not exist on your default location"
              components={{ 1: <strong /> }}
              values={{ resourceType }}
            />
          </p>
          <p>
            <Trans
              i18nKey="The resource type <1>'{{resourceType}}'</1> can be found on a different location."
              components={{ 1: <strong /> }}
              values={{ resourceType }}
            />
          </p>
          <p>
            <Trans
              i18nKey="<1>Click here</1> to add the resource type to your default location settings."
              components={{ 1: <span className="text-blue-500 cursor-pointer" onClick={handleToChangeLocation} /> }}
            />
          </p>
        </>
      )}
    </div>
  );
};

export default NoResultFound;
